<template>
    <stats-card
    type="successDash" 
    style="min-height:132px"
    >
    <template slot="header" >
      <p class="fake-title">{{i18nValues['coupons']}}<span style="color:black"> {{snapshot.currentCouponMessages}}</span></p>
      <p class="fake-title">{{i18nValues['messages']}}<span style="color:black"> {{snapshot.currentMsgMessages}}</span></p>
    </template>
    <template slot="content">
      <p class="fake-title" style="text-align: right;">{{i18nValues['targeted']}}<span style="color:black"> {{snapshot.currentTargetedMessages}}</span></p>
      <p class="fake-title" style="text-align: right;">{{i18nValues['giftcards']}}<span style="color:black"> {{snapshot.currentGCMessages}}</span></p>
    </template>
    <div class="stats align-between" slot="footer">
        <el-tooltip placement="bottom" effect="light" popper-class="tooltipSmall">
        <div slot="content" class="p-10">
            <el-table
            :data="detail"
            class="table tableTooltip table-hover table-striped no-more-tables no-margin">
            <el-table-column prop="type" :label="i18nValues['type']" align="left"></el-table-column>
            <el-table-column prop="cant" :label="i18nValues['quantity']" align="right"></el-table-column>
            </el-table>
        </div>
        <el-button
            class="btn-tooltip text-grey"
            size="small"
            icon="nc-icon nc-bookmark-2"
        >{{i18nValues['detail']}}</el-button>
        </el-tooltip>
    </div>
    </stats-card>
</template>
<script>
import { StatsCard } from "@/components/dashboard/index";
export default {
  name: "CouponsSection",
  props: {
      snapshot: Object,
      detail: Array,
  },
  components: {
    StatsCard,
  }
}
</script>
<style scoped>
.align-between {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.btn-tooltip {
  border: 0px !important;
  background-color: white !important;
}
.btn-tooltip:hover,
.btn-tooltip:focus {
  background-color: white !important;
}
.btn-tooltip {
  font-size: 14px !important;
  padding: 0px 0px;
}
.text-grey {
  color: #a49e93 !important;
}
.p-10 {
  padding: 10px;
}
.container {
  display: flex;
}
.container.space-around {
  justify-content: space-around;
}
.container.space-between {  
  justify-content: space-between;
}
.fake-title {
    font-size: 16px;
    font-weight: 400;
    color: #9A9A9A;
    margin-bottom: 0px;
}
</style>